import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { dbObjectToId, sortArray } from '@nu-art/ts-common';
import { TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/components/TS_MultiSelect/index';
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionDomain, ModuleFE_PermissionGroup } from '../_entity.js';
import { DropDown_PermissionAccessLevel } from '../_entity/permission-access-level/ui-components.js';
import { DropDown_PermissionProject } from '../_entity/permission-project/ui-components.js';
import { DropDown_PermissionDomain } from '../_entity/permission-domain/ui-components.js';
import { DropDown_PermissionGroup } from '../_entity/permission-group/ui-components.js';
import { TS_Icons } from '@nu-art/ts-styles';
export const Permissions_DropDown = {
    Project: DropDown_PermissionProject.selectable,
    AccessLevel: DropDown_PermissionAccessLevel.selectable,
    Domain: DropDown_PermissionDomain.selectable,
    Group: DropDown_PermissionGroup.selectable,
};
class DomainLevelRenderer extends ComponentSync {
    render() {
        const selectedLevels = ModuleFE_PermissionAccessLevel.cache.filter(item => this.props.existingItems.includes(item._id));
        const availableDomainsIds = ModuleFE_PermissionDomain.cache.filter(item => !selectedLevels.find(level => level.domainId === item._id)).map(dbObjectToId);
        return _jsxs(LL_V_L, { className: 'domain-level-renderer', children: [_jsx(Permissions_DropDown.Domain, { selected: this.state.domainId, queryFilter: domain => availableDomainsIds.includes(domain._id), onSelected: domain => this.setState({ domainId: domain._id }), sortBy: ['namespace'], placeholder: 'Domain' }), _jsx(Permissions_DropDown.AccessLevel, { disabled: !this.state.domainId, queryFilter: level => this.state.domainId === level.domainId, selected: undefined, onSelected: (accessLevel) => this.props.onSelected(accessLevel._id), sortBy: ['value'], placeholder: 'Level' })] });
    }
    deriveStateFromProps(nextProps, state) {
        return { domainId: undefined, onSelected: nextProps.onSelected };
    }
}
class GroupRenderer extends ComponentSync {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        return _jsx(Permissions_DropDown.Group, { onSelected: group => this.props.onSelected({ groupId: group._id }), queryFilter: group => !this.props.existingItems.find(g => g.groupId === group._id), sortBy: ['label'], selected: undefined });
    }
}
const AccessLevelItemRenderer = (levelId) => {
    const level = ModuleFE_PermissionAccessLevel.cache.unique(levelId);
    const domain = ModuleFE_PermissionDomain.cache.unique(level?.domainId);
    return `${domain?.namespace ?? 'Not Found'}: ${level?.name ?? 'Not Found'} (${level?.value ?? '#'})`;
};
const MultiSelect_PermissionsAccessLevel = {
    itemRenderer: (accessLevelId, onDelete) => _jsxs(_Fragment, { children: [AccessLevelItemRenderer(accessLevelId), _jsx(TS_Icons.x.component, { onClick: onDelete })] }),
    selectionRenderer: (props) => _jsx(DomainLevelRenderer, { onSelected: props.onSelected, className: props.className, existingItems: props.existingItems, queryFilter: props.queryFilter }),
    sort: items => sortArray(items, AccessLevelItemRenderer)
};
const MultiSelect_PermissionsAccessLevelStam = {
    itemRenderer: (accessLevelId, onDelete) => _jsxs(_Fragment, { children: [_jsx("div", { className: "ts-icon__small", onClick: onDelete, children: "X" }), _jsx("span", { children: ModuleFE_PermissionAccessLevel.cache.unique(accessLevelId)?.name || 'not found' })] }),
    selectionRenderer: (selector) => _jsx(Permissions_DropDown.AccessLevel, { queryFilter: item => {
            const selectedLevels = ModuleFE_PermissionAccessLevel.cache.filter(item => selector.existingItems.includes(item._id));
            const availableDomainsIds = ModuleFE_PermissionDomain.cache.filter(item => !selectedLevels.find(level => level.domainId === item._id)).map(dbObjectToId);
            return availableDomainsIds.includes(item.domainId);
        }, onSelected: item => selector.onSelected(item._id) })
};
const MultiSelect_PermissionsGroup = {
    itemRenderer: (group, onDelete) => _jsxs(_Fragment, { children: [ModuleFE_PermissionGroup.cache.unique(group?.groupId)?.label || 'not found', _jsx(TS_Icons.x.component, { className: "ts-icon__small", onClick: onDelete })] }),
    selectionRenderer: (props) => _jsx(GroupRenderer, { onSelected: props.onSelected, className: props.className, existingItems: props.existingItems, queryFilter: props.queryFilter }),
    sort: items => sortArray(items, item => ModuleFE_PermissionGroup.cache.unique(item?.groupId)?.label || 'not found')
};
export const MultiSelect = {
    AccessLevel_StamTest: TS_MultiSelect_V2.prepare(MultiSelect_PermissionsAccessLevelStam),
    AccessLevel: TS_MultiSelect_V2.prepare(MultiSelect_PermissionsAccessLevel),
    Group: TS_MultiSelect_V2.prepare(MultiSelect_PermissionsGroup),
};
//# sourceMappingURL=ui-props.js.map